//frontend\src\components\IntroTextOverlay.jsx
import { motion, AnimatePresence } from "framer-motion";

const textWords = ["VetAssist", "Clinic", "Software"];

const container = {
  hidden: { opacity: 1 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.3,
    },
  },
};

const word = {
  hidden: {
    y: "130%",
    skewY: 7,
    opacity: 0,
  },
  show: {
    y: "0%",
    skewY: 0,
    opacity: 1,
    transition: {
      duration: 1.1,
      ease: [0.19, 1, 0.22, 1],
    },
  },
};

const topBadge = {
  hidden: { opacity: 0, scale: 0.9 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut", delay: 0.1 },
  },
};

const accentLine = {
  hidden: { width: 0 },
  show: {
    width: "60px",
    transition: { duration: 1, ease: "easeInOut", delay: 1 },
  },
};

const IntroTextOverlay = ({ visible }) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          exit={{
            opacity: 0,
            filter: "blur(10px)",
            transition: { duration: 0.4 },
          }}
          className="fixed inset-0 z-100 flex flex-col items-center justify-center gap-8 bg-white pointer-events-none"
        >
          <motion.div
            variants={topBadge}
            className="flex items-center gap-3 px-4 text-center"
          >
            <motion.span
              variants={accentLine}
              className="hidden sm:block h-px bg-[#295CAC]"
            />
            <span className="text-[10px] sm:text-xs uppercase tracking-[0.35em] text-slate-400 font-semibold whitespace-nowrap">
              Clinic First
            </span>
            <motion.span
              variants={accentLine}
              className="hidden sm:block h-px bg-[#1A3A5C]"
            />
          </motion.div>

          <div className="overflow-hidden px-4 w-full">
            <div className="mx-auto flex max-w-[90vw] flex-wrap justify-center gap-x-3 gap-y-1 text-center">
              {textWords.map((item, i) => (
                <div key={i} className="overflow-hidden">
                  <motion.span
                    variants={word}
                    className="block whitespace-nowrap text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight text-slate-800"
                  >
                    {item}
                  </motion.span>
                </div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5 }}
            className="flex flex-col items-center gap-2"
          >
            <div className="w-px h-12 bg-linear-to-b from-slate-200 to-transparent" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroTextOverlay;